<template>
    <div :id="`section-${id}`" class="section">
       <slot></slot>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import inViewport from 'vue-in-viewport-mixin';

export default {
  name: 'Section',
  mixins: [inViewport],
  data() {
    return {
      fully: false,
      below: false,
      now: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('sections', ['isScrolling']),
    active() {
      const { fully, now, below } = this;
      return fully || (now && below);
    },
  },
  watch: {
    'inViewport.fully': {
      handler(fully) {
        this.fully = !!fully;
      },
    },
    'inViewport.now': {
      handler(now) {
        this.now = !!now;
      },
    },
    'inViewport.below': {
      handler(below) {
        this.below = !!below;
      },
    },
    active: {
      handler(active) {
        const { setActiveSectionLink, id, isScrolling } = this;
        if (active && !isScrolling) {
          setActiveSectionLink(id);
        }
      },
    },
  },
  methods: {
    ...mapMutations('sections', ['setActiveSectionLink']),
  },
};
</script>
<style lang="stylus" scoped>
@import '../styles/variables';
.section{
  position: relative
}
@media (min-width: $breakpoint-sm) {
}
</style>
